export default __webpack_public_path__ + "static/media/info_1_mobile.5c3d8e88.png";